<template>
  <!-- A person: initials on their colour (kit PersonDot). -->
  <span
    class="person-dot"
    :class="{ 'has-picture': picture && !failed }"
    :style="{
      width: size + 'px',
      height: size + 'px',
      background: color,
      color: onPerson,
      fontSize: Math.round(size * 0.4) + 'px',
      boxShadow: ring ? `0 0 0 2px ${ring}` : 'none',
    }"
    :title="name"
  ><img v-if="picture && !failed" :src="picture" alt="" class="person-dot-img" @error="failed = true" /><template v-else>{{ letters }}</template></span>
</template>

<script>
import { ON_PERSON, initials } from "@/kit/people.js";

export default {
  name: "PersonDot",
  props: {
    name: { type: String, default: "" },
    color: { type: String, required: true },
    size: { type: Number, default: 28 },
    // Ring colour (the surface behind overlapping dots).
    ring: { type: String, default: null },
    // A picture fills the dot; the initials are the fallback.
    picture: { type: String, default: null },
  },
  data: () => ({ onPerson: ON_PERSON, failed: false }),
  watch: {
    picture() {
      this.failed = false;
    },
  },
  computed: {
    letters() {
      return initials(this.name);
    },
  },
};
</script>

<style scoped>
.person-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 700;
  flex-shrink: 0;
  line-height: 1;
}
.person-dot.has-picture {
  overflow: hidden;
}
.person-dot-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
